import React from 'react';

import useHandleCopyWithToast from '../../utils/handleCopyWithToast';
import { useUiComponentsInternationalContext } from '@repo/static-translations';

interface ReferralCodeProps {
  referralCode: string;
}

const ReferralCode = ({ referralCode }: ReferralCodeProps) => {
  const { tt } = useUiComponentsInternationalContext();
  const handleCopyWithToast = useHandleCopyWithToast();

  return (
    <div className="flex self-stretch mb-2">
      <div className="flex flex-col items-center self-stretch gap-2 w-full">
        <p className="m-0 text-sm">
          {tt(
            s => s.referralProgramComponent.yourUniqueReferralCodeDescription
          )}
        </p>
        <button
          type="button"
          className="m-0 text-lg font-bold text-primary hover:underline"
          onClick={() =>
            handleCopyWithToast(
              referralCode,
              tt(s => s.referralProgramComponent.referralCodeLabel)
            )
          }
        >
          {referralCode}
        </button>
      </div>
    </div>
  );
};

export default ReferralCode;
